import React from 'react';
import { toast } from 'react-toastify';
import { ClipboardDocumentIcon } from '@heroicons/react/24/outline';
import { isPaymentLink } from '@claimup/shared/helpers/payment-link';

/**
 * El enlace de pago propio del cliente (`url_pago_propia_cliente`), que entra
 * por la API y por la importadora y hasta ahora no se veía en la ficha.
 *
 * Sin enlace dice «No facilitado» en vez de esconderse: una línea que
 * desaparece se lee como «el cliente no lo mandó», y no siempre es así.
 * Solo se enlaza si es http(s); cualquier otra cosa se enseña como texto.
 */
const PaymentLinkField = ({ url }) => {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success('Enlace copiado');
    } catch {
      toast.error('No se pudo copiar el enlace');
    }
  };

  return (
    <div>
      <h2 className='text-sm font-medium text-gray-500'>Enlace de pago del cliente</h2>
      {url ? (
        <div className='mt-1 flex items-center gap-2 min-w-0'>
          {isPaymentLink(url) ? (
            <a
              href={url}
              target='_blank'
              rel='noopener noreferrer'
              className='text-base text-blue-600 hover:text-blue-700 underline truncate'
              title={url}
            >
              {url}
            </a>
          ) : (
            <span className='text-base text-gray-800 truncate' title={url}>
              {url}
            </span>
          )}
          <button
            type='button'
            onClick={copy}
            className='shrink-0 p-1 rounded-lg text-gray-500 hover:text-gray-700 hover:bg-gray-100'
            aria-label='Copiar enlace de pago'
            title='Copiar'
          >
            <ClipboardDocumentIcon className='w-5 h-5' />
          </button>
        </div>
      ) : (
        <p className='mt-1 text-base text-gray-400'>No facilitado</p>
      )}
    </div>
  );
};

export default PaymentLinkField;
